import { render, staticRenderFns } from "./BasicInfoRecalculation.vue?vue&type=template&id=304467c4&scoped=true&"
import script from "./BasicInfoRecalculation.vue?vue&type=script&lang=js&"
export * from "./BasicInfoRecalculation.vue?vue&type=script&lang=js&"
import style0 from "./BasicInfoRecalculation.vue?vue&type=style&index=0&id=304467c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304467c4",
  null
  
)

export default component.exports